import React, { Fragment } from "react";
import Container from '../../../core/controls/components/container'
import adminswitchusergrid from '../../jsons/switchuser/adminswitchusergrid';

const switchuserscreen = (props) => {

    return (
        <Fragment>
            <Container {...adminswitchusergrid} />
        </Fragment>
    )
}

export default switchuserscreen